import angular from 'angular';
import fileUpload from '../../../common/const/file-upload';
import { directive, controller } from '../controllers/app';
import { schemaStore } from '../../../common/validate';

function makeOtRowActions($scope) {
  return {
    onEditRow: function onEditRow(id) {
      $scope.editing = $scope.editing === id ? null : id;
    },
    onDeleteRow: function onDeleteRow(id) {
      delete $scope.data[id];
      $scope.active = Object.keys($scope.data).length > 0;
      $scope.editing = null;
    },
    onSaveRow: function(id, obj) {
      $scope.editing = null;
      delete $scope.data[id];
      id = obj.lei;
      delete obj.lei;
      $scope.data[id] = obj;
    }
  };
}

function parseFiles(files) {
  var file = files[0]; // FileList object.
  this.error.other = '';
  this.error.maxSize = file.size >= this.fileUpload.max_file_size;
  this.error.pattern = !/\.csv$/.test(file.name);
  this.file = this.error.maxSize || this.error.pattern ? null : file;
}

function onUpload(AM, PM, callback, clear) {
  AM.reset();
  PM.reset().progress(25);

  var reader = new FileReader();
  reader.onerror = function onError(event) {
    AM.reset();
    switch (event.target.error.code) {
      case event.target.error.NOT_FOUND_ERR:
        return (this.error = 'File Not Found!');
      case event.target.error.NOT_READABLE_ERR:
        return (this.error = 'File is not readable');
      case event.target.error.ABORT_ERR:
        break; // noop
      default:
        this.error = 'An error occurred reading this file.';
    }
  };
  reader.onloadend = function onLoad() {
    AM.reset();
    callback(reader.result, clear);
  };
  reader.onabort = function onAbort() {
    AM.reset();
    this.error = 'File read cancelled';
  };

  // Read in the image file as a binary string.
  reader.readAsText(this.file);
}

import views_users_ownershipTransfer from '@lei-website-client/views/users/ownershipTransfer.html';

directive('ownershipTransfer', [
  'UserService',
  'ProgressMessenger',
  'AlertMessenger',
  'Alert',
  'DefaultErrorHandler',
  function(UserService, ProgressMessenger, AlertMessenger, Alert, DefaultErrorHandler) {
    return {
      restrict: 'A',
      scope: true,
      template: views_users_ownershipTransfer,
      link: link
    };

    function link($scope, $element) {
      var notified = false;
      $scope.file;
      $scope.editing = null;
      $scope.active = false;
      $scope.submitting = false;
      $scope.actionMode = 'claim'; // Default to claim mode
      $scope.single = {};
      $scope.data = {};
      $scope.claim = {
        authorizationDocuments: [],
        customerAgreement: false
      };
      $scope.fileUpload = fileUpload;
      $scope.error = {
        maxSize: false,
        pattern: false,
        other: '',
        authDocMaxSize: false,
        authDocPattern: false,
        authDocRequired: false
      };
      $scope.schema = schemaStore.get('ownershipTransfer');

      // Initialize Bootstrap tooltips with faster delay
      setTimeout(function() {
        $element.find('[data-toggle="tooltip"]').tooltip({
          delay: { show: 200, hide: 0 }
        });
      }, 0);

      $scope.onSubmit = function onSubmit() {
        if ($scope.submitting) return;
        $scope.submitting = true;
        AlertMessenger.reset();
        return UserService.ownershipTransfer($scope.data)
          .then(function() {
            Alert.success('bulkOwnershipTransfer');
            $scope.data = {};
          }, DefaultErrorHandler)
          .catch(angular.noop)
          .finally(function() {
            $scope.submitting = false;
          });
      };

      $scope.onSubmitClaim = function onSubmitClaim() {
        if ($scope.submitting) return;
        AlertMessenger.reset();

        // Validate that at least one authorization document is uploaded
        if (!$scope.claim.authorizationDocuments || $scope.claim.authorizationDocuments.length === 0) {
          $scope.error.authDocRequired = true;
          AlertMessenger.error('At least one authorization document is required for claiming an LEI.');
          return;
        }

        $scope.submitting = true;

        // Create FormData to send files along with data
        var formData = new FormData();

        // Add all authorization document files
        if ($scope.claim.authorizationDocuments && $scope.claim.authorizationDocuments.length) {
          $scope.claim.authorizationDocuments.forEach(function(file) {
            formData.append('files', file);
          });
        }

        // Add data as JSON strings (backend expects this format)
        formData.append(
          'customerAgreement',
          JSON.stringify({
            acceptedCustomerAgreement: $scope.claim.customerAgreement || false,
            acceptedTransferWaiver: false
          })
        );
        formData.append('processedPayload', JSON.stringify($scope.data));

        // Add the claim flag to route to claimLei function
        formData.append('isClaim', true);

        return UserService.ownershipTransfer(formData)
          .then(function(ids) {
            Alert.success('bulkOwnershipClaim', null, [
              ids.data.map(data => `${data.humanReadableId}(LEI: ${data.lei})`)
            ]);
            $scope.data = {};
            $scope.claim.authorizationDocuments = [];
            $scope.claim.customerAgreement = false;
            $scope.claim.authorizationDocumentUploaded = false;
          }, DefaultErrorHandler)
          .catch(angular.noop)
          .finally(function() {
            $scope.submitting = false;
          });
      };

      $scope.onAddElement = function onAddElement() {
        if ($scope.actionMode === 'claim') {
          // Claim mode: no username needed
          $scope.data[$scope.single.lei] = {};
        } else {
          // Transfer mode: username required
          $scope.data[$scope.single.lei] = { user: $scope.single.user };
        }
        delete $scope.single.lei;
        delete $scope.single.user;
        $scope.ownershipForm.lei.$setUntouched();
        if ($scope.ownershipForm.user) {
          $scope.ownershipForm.user.$setUntouched();
        }
        $scope.active = Object.keys($scope.data).length > 0;
        if (!notified) {
          AlertMessenger.info('Please verify your ownership actions in the table below.');
          notified = true;
        }
      };

      $scope.rowActions = makeOtRowActions($scope);

      $scope.resetForm = function resetForm() {
        // Reset single entry form
        $scope.single = {};
        if ($scope.ownershipForm) {
          $scope.ownershipForm.$setPristine();
          $scope.ownershipForm.$setUntouched();
        }

        // Reset bulk upload
        $scope.file = null;
        $scope.data = {};
        $scope.active = false;
        $scope.editing = null;
        $scope.submitting = false;
        notified = false;

        // Reset errors
        $scope.error = {
          maxSize: false,
          pattern: false,
          other: '',
          authDocMaxSize: false,
          authDocPattern: false,
          authDocRequired: false
        };

        // Reset claim-specific data
        $scope.claim = {
          authorizationDocuments: [],
          customerAgreement: false,
          authorizationDocumentUploaded: false
        };

        // Reset alerts
        AlertMessenger.reset();
      };

      $scope.onAuthLetterChange = function onAuthLetterChange($newFiles) {
        if (!$newFiles || !$newFiles.length) {
          return;
        }

        // Support multiple files - append to existing array
        if (!$scope.claim.authorizationDocuments) {
          $scope.claim.authorizationDocuments = [];
        }

        $newFiles.forEach(function(file) {
          // Validate each file
          var maxSizeError = file.size >= $scope.fileUpload.max_file_size;
          var patternError = !/\.(pdf|doc|docx)$/i.test(file.name);

          if (maxSizeError) {
            $scope.error.authDocMaxSize = true;
            AlertMessenger.error(
              'File "' +
                file.name +
                '" is too large. Must be less than ' +
                $scope.fileUpload.max_file_size / (1024 * 1024) +
                'MB.'
            );
            return;
          }

          if (patternError) {
            $scope.error.authDocPattern = true;
            AlertMessenger.error('File "' + file.name + '" must be PDF, DOC, or DOCX format.');
            return;
          }

          // Check if file already exists (by name and size)
          var isDuplicate = $scope.claim.authorizationDocuments.some(function(existing) {
            return existing.name === file.name && existing.size === file.size;
          });

          if (!isDuplicate) {
            $scope.claim.authorizationDocuments.push(file);
          }
        });

        // Clear errors if successful
        if ($scope.claim.authorizationDocuments.length > 0) {
          $scope.error.authDocMaxSize = false;
          $scope.error.authDocPattern = false;
          $scope.error.authDocRequired = false;
        }
      };

      $scope.removeAuthDocument = function removeAuthDocument(file) {
        var index = $scope.claim.authorizationDocuments.indexOf(file);
        if (index > -1) {
          $scope.claim.authorizationDocuments.splice(index, 1);
        }
      };

      $scope.onUploadAuthLetter = function onUploadAuthLetter(replace) {
        if (!$scope.claim.authorizationDocuments || !$scope.claim.authorizationDocuments.length) {
          return;
        }

        // Mark that authorization document has been uploaded
        $scope.claim.authorizationDocumentUploaded = true;

        if (replace) {
          AlertMessenger.info('Authorization documents replaced successfully.');
        } else {
          AlertMessenger.info('Authorization documents uploaded successfully.');
        }
      };

      $scope.parseFiles = parseFiles.bind($scope);
      $scope.onUpload = onUpload.bind($scope, AlertMessenger, ProgressMessenger, function parseContent(content, clear) {
        var data = {};
        var lineNo = 0;
        var lines = content.split(/\r?\n/);
        for (var i = 0; i < lines.length; i++) {
          var line = lines[i].trim();
          if (!line) continue;

          lineNo++;

          var item = line.split(',').map(function(s) {
            return s.trim();
          });

          if (lineNo === 1) {
            // Validate header row based on action mode
            if ($scope.actionMode === 'claim') {
              if (!item[0] || item[0].toUpperCase() !== 'LEI') {
                return Alert.error('invalidCsvHeaderClaim');
              }
            } else {
              // Transfer mode: LEI, Destination Username
              if (
                item.length < 2 ||
                !item[0] ||
                !item[1] ||
                item[0].toUpperCase() !== 'LEI' ||
                item[1].toUpperCase() !== 'DESTINATION USERNAME'
              ) {
                return Alert.error('invalidCsvHeaderTransfer');
              }
            }
            continue;
          }

          if ($scope.actionMode === 'claim') {
            // Claim mode: only use first column (LEI), ignore any other columns
            var lei = item[0];
            if (!lei) return Alert.error('mandatoryOwnershipTransfer', null, ['LEI', lineNo]);
            data[lei] = {};
          } else {
            // Transfer mode: lei, username (2 columns required)
            if (item.length < 2) return Alert.error('fileFormatOwnershipTransfer', null, [lineNo]);

            if (!item[0]) return Alert.error('mandatoryOwnershipTransfer', null, ['LEI', lineNo]);
            if (!item[1]) return Alert.error('mandatoryOwnershipTransfer', null, ['destination username', lineNo]);
            data[item[0]] = { user: item[1] };
          }

          if (!notified) {
            AlertMessenger.info('Please verify your ownership actions in the table below.');
            notified = true;
          }
        }

        if (lineNo < 2) return Alert.error('emptyOwnershipTransferFile');

        if (lineNo > $scope.fileUpload.max_ownership_transfer_size + 1) return Alert.error('maxSizeOwnershipTransfer');

        $scope.data = clear ? data : Object.assign($scope.data, data);
        $scope.active = Object.keys($scope.data).length > 0;
      });
    }
  }
]);

import views_templates_ownershipTransferRow from '@lei-website-client/views/templates/ownershipTransferRow.html';

directive('ownershipTransferRow', [
  function() {
    return {
      restrict: 'A',
      scope: {
        active: '<',
        schema: '<',
        owner: '<?',
        data: '<',
        lei: '<',
        actions: '<',
        form: '<'
      },
      link: link,
      template: views_templates_ownershipTransferRow
    };

    function link($scope) {
      $scope.obj = Object.assign({ lei: $scope.lei }, $scope.data);
      $scope.onBlue = function() {
        if (!$scope.active) {
          $scope.obj = Object.assign({ lei: $scope.lei }, $scope.data);
          return $scope.actions.onEditRow($scope.lei);
        }
        return $scope.actions.onSaveRow($scope.lei, $scope.obj);
      };
      $scope.onRed = function() {
        return !$scope.active ? $scope.actions.onDeleteRow($scope.lei) : $scope.actions.onEditRow($scope.lei);
      };
    }
  }
]);

angular.module('leiApp.controllers');
controller('AdminTransferLeiController', [
  '$scope',
  'AdminService',
  'DefaultErrorHandler',
  'ProgressMessenger',
  'AlertMessenger',
  'Alert',
  function($scope, AdminService, DefaultErrorHandler, ProgressMessenger, AlertMessenger, Alert) {
    var notified = false;
    $scope.file;
    $scope.active = false;
    $scope.editing = null;
    $scope.submitting = false;
    $scope.single = {};
    $scope.data = {};
    $scope.fileUpload = fileUpload;
    $scope.error = {
      maxSize: false,
      pattern: false,
      other: ''
    };
    $scope.schema = schemaStore.get('ownershipTransfer');

    $scope.onSubmit = function onSubmit() {
      if ($scope.submitting) return;
      $scope.submitting = true;
      AlertMessenger.reset();
      return AdminService.ownershipTransfer($scope.data)
        .then(function() {
          Alert.success('bulkOwnershipTransfer');
          $scope.data = {};
        }, DefaultErrorHandler)
        .finally(function() {
          $scope.submitting = false;
        });
    };

    $scope.onAddElement = function onAddElement() {
      $scope.data[$scope.single.lei] = {
        owner: $scope.single.owner,
        user: $scope.single.user
      };
      delete $scope.single.lei;
      $scope.ownershipForm.lei.$setUntouched();
      $scope.active = Object.keys($scope.data).length > 0;
      if (!notified) {
        AlertMessenger.info('Please verify your ownership actions in the table below.');
        notified = true;
      }
    };

    $scope.rowActions = makeOtRowActions($scope);
    $scope.parseFiles = parseFiles.bind($scope);
    $scope.onUpload = onUpload.bind($scope, AlertMessenger, ProgressMessenger, function parseContent(content, clear) {
      var data = {};
      var lineNo = 0;
      var lines = content.split(/\r?\n/);
      for (var i = 0; i < lines.length; i++) {
        var line = lines[i].trim();
        if (!line) continue;

        lineNo++;

        // lei, fromusername, tousername
        var item = line.split(',').map(function(s) {
          return s.trim();
        });

        if (lineNo === 1) {
          // Validate header row - LEI, Original Username, Destination Username
          if (
            item.length < 3 ||
            !item[0] ||
            !item[1] ||
            !item[2] ||
            item[0].toUpperCase() !== 'LEI' ||
            item[1].toUpperCase() !== 'ORIGINAL USERNAME' ||
            item[2].toUpperCase() !== 'DESTINATION USERNAME'
          ) {
            return Alert.error('invalidCsvHeaderTransferAdmin');
          }
          continue;
        }

        if (item.length < 3) return Alert.error('fileFormatOwnershipTransfer', null, [lineNo]);

        if (!item[0]) return Alert.error('mandatoryOwnershipTransfer', null, ['LEI', lineNo]);
        if (!item[1]) return Alert.error('mandatoryOwnershipTransfer', null, ['original username', lineNo]);
        if (!item[2]) return Alert.error('mandatoryOwnershipTransfer', null, ['destination username', lineNo]);

        if (item[1] === item[2]) return Alert.error('selfOwnershipTransfer', [lineNo]);

        data[item[0]] = {
          owner: item[1],
          user: item[2]
        };

        if (!notified) {
          AlertMessenger.info('Please verify your ownership actions in the table below.');
          notified = true;
        }
      }

      if (lineNo < 2) return Alert.error('emptyOwnershipTransferFile');

      if (lineNo > $scope.fileUpload.max_ownership_transfer_size + 1) return Alert.error('maxSizeOwnershipTransfer');

      $scope.data = clear ? data : Object.assign($scope.data, data);
      $scope.active = Object.keys($scope.data).length > 0;
    });
  }
]);
